<template>
  <v-animation
    v-if="isLoading"
    height="10"
    width="10"
    style="margin-top:4px"
  />
  <v-icon
    v-else
    :icon="icon"
    class="cursor-pointer"
    @click="setLoader"
  />
</template>
<script>
import { debounce } from 'lodash-es';

import Icon from '@/components/common/helpers/Icon.vue';
import LoadingAnimation from '@/components/common/helpers/LoadingAnimation.vue';

export default {
  name: 'LoaderIcon',
  components: {
    'v-icon': Icon,
    'v-animation': LoadingAnimation,
  },
  props: {
    action: {
      type: Function,
      default: () => Promise.resolve(),
    },
    icon: {
      type: String,
      default: 'trash',
    },
  },
  data() {
    return {
      isLoading: false,
      debouncer: { cancel: () => {} },
    };
  },
  methods: {
    setLoader() {
      this.debouncer.cancel();
      this.isLoading = true;
      const toBeCalled = async () => {
        try { await this.action(); } finally { this.isLoading = false; }
      };
      this.debouncer = debounce(
        toBeCalled,
        300,
      );
      this.debouncer();
    },
  },
};
</script>
